/**
 * @module root
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
/* tslint:disable:no-any */
import { of } from 'rxjs';
import { ConfigLoader } from './config-loader';
import { Injectable } from '@angular/core';

/**
 * AppConfig wrapper for config loader
 */

@Injectable()
export class AppConfig {
  private configLoader: ConfigLoader;
  constructor() {
    this.configLoader = new ConfigLoader();
  }

  /**
   * getConfig method to provide values of given keys
   * @param key: string
   * @return any
   */
  public getConfig(key: string): any {
    return this.configLoader.getConfig(key);
  }
  public getProxyUrl(key: string): string {
    return this.getConfig('proxyNames')[key] || '';
  }
}
